import 'Styles/settings.scss';

import React from 'react';
import { connect } from 'react-redux';

import settingsSelector from 'Selectors/settingsSelector';
import CheckboxComponent from 'Components/common/CheckboxComponent';

import { receiveGlobalMeta } from 'Actions/MetaActions';
import { pingServer } from 'Actions/GlobalMetaActions';
import { saveSetting } from 'Actions/UserSettingsActions';

import { trackGAEvent } from 'Actions/adsActions';

class SettingsComponent extends React.Component {
	constructor( props ) {
		super( props );

		this.state = { ...this.props.userSettings };
	}

	componentWillMount() {
		this.props.dispatch( pingServer() );
	}

	componentDidMount() {
		this.props.dispatch( receiveGlobalMeta( null, 'Settings', this.props.siteTitle ) );
		window.scrollTo( 0, 0 );
	}

	updateState( event ) {
		let value = event.target.checked ? event.target.value : false,
			newStateProp = { [event.target.name]: ( event.target.type === 'checkbox' && value ? true : value ) };

		this.setState( newStateProp );
		this.props.dispatch( saveSetting( newStateProp ) );
		this.props.dispatch( trackGAEvent(false, event.target.name + '_' + newStateProp[ event.target.name ], 'userAction', 'settings') );
	};

	render() {
		let whosonline = ( this.props.ustate.perms && this.props.ustate.perms.whosonline ) ?
			<li className="settings-option">
				<h1>Online Users List Sorting</h1>
				<ul>
					<li className="option">
						<CheckboxComponent
							name="onlineUsersLoadingBehavior"
							id="online-loading-behavior_recent"
							postLabel="Recent first"
							value="recent"
							className="inLine"
							checked={ this.state.onlineUsersLoadingBehavior === 'recent' }
							multiple={ false }
							onChange={ ( e ) => this.updateState( e ) }
						/>
					</li>
					<li className="option">
						<CheckboxComponent
							name="onlineUsersLoadingBehavior"
							id="online-loading-behavior_oldest"
							postLabel="UserName A -> Z"
							value="az"
							className="inLine"
							checked={ this.state.onlineUsersLoadingBehavior === 'az' }
							multiple={ false }
							onChange={ ( e ) => this.updateState( e ) }
						/>
					</li>
					<li className="option">
						<CheckboxComponent
							name="onlineUsersLoadingBehavior"
							id="online-loading-behavior_newest"
							postLabel="UserName Z -> A"
							value="za"
							className="inLine"
							checked={ this.state.onlineUsersLoadingBehavior === 'za' }
							multiple={ false }
							onChange={ ( e ) => this.updateState( e ) }
						/>
					</li>
				</ul>
			</li> : null;

		return (
			<div className="settings thread">
				<ul className="settings-form">
					<li className="settings-option">
						<h1>Loading Behavior</h1>
						<div className="note">On those pages where sorting is available</div>
						<ul>
							<li className="option">
								<CheckboxComponent
									name="loadingBehavior"
									id="loading-behavior_oldest"
									postLabel="Oldest first"
									value="oldest"
									className="inLine"
									checked={ this.state.loadingBehavior === 'oldest' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="loadingBehavior"
									id="loading-behavior_newest"
									postLabel="Newest first"
									value="newest"
									className="inLine"
									checked={ this.state.loadingBehavior === 'newest' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
					{ whosonline }
					<li className="settings-option">
						<h1>Items Per Page</h1>
						<div className="note">When an option other than 'Same as desktop' is selected any change on desktop settings for this will be ignored</div>
						<ul>
							<li className="option">
								<CheckboxComponent
									name="pageSize"
									id="items-per-page_0"
									postLabel={ `Same value as desktop ( currently ${ this.props.ustate.pageSize ? this.props.ustate.pageSize : 10 } )` }
									value="0"
									className="inLine"
									checked={ parseInt( this.state.pageSize ) === 0 }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="pageSize"
									id="items-per-page_10"
									postLabel="10 items per page (default)"
									value="10"
									className="inLine"
									checked={ parseInt( this.state.pageSize ) === 10 }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="pageSize"
									id="items-per-page_20"
									postLabel="20 items per page"
									value="20"
									className="inLine"
									checked={ parseInt( this.state.pageSize ) === 20 }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="pageSize"
									id="items-per-page_50"
									postLabel="50 items per page"
									value="50"
									className="inLine"
									checked={ parseInt( this.state.pageSize ) === 50 }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
					<li className="settings-option">
						<h1>Theme</h1>
						<ul>
							<li className="option">
								<CheckboxComponent
									name="styleTheme"
									id="style-theme_dark"
									postLabel="Dark theme"
									value="dark"
									className="inLine"
									checked={ this.state.styleTheme === 'dark' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="styleTheme"
									id="style-theme_light"
									postLabel="Light theme (default)"
									value="light"
									className="inLine"
									checked={ this.state.styleTheme === 'light' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
					<li className="settings-option">
						<h1>Font Size</h1>
						<ul>
							<li className="option">
								<CheckboxComponent
									name="fontSize"
									id="font-size_small"
									postLabel="Small"
									value="small"
									className="inLine fontSize-small"
									checked={ this.state.fontSize === 'small' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="fontSize"
									id="font-size_normal"
									postLabel="Normal"
									value="normal"
									className="inLine fontSize-normal"
									checked={ this.state.fontSize === 'normal' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="fontSize"
									id="font-size_big"
									postLabel="Big"
									value="big"
									className="inLine fontSize-big"
									checked={ this.state.fontSize === 'big' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="fontSize"
									id="font-size_huge"
									postLabel="Huge"
									value="huge"
									className="inLine fontSize-huge"
									checked={ this.state.fontSize === 'huge' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
					<li className="settings-option">
						<h1>Attachment Previews</h1>
						<ul>
							<li className="option">
								<CheckboxComponent
									name="showAttachmentsPreview"
									id="attachment-previews"
									value="true"
									className="inLine"
									postLabel="Show Attachment Previews"
									checked={ this.state.showAttachmentsPreview === true }
									multiple={ true }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
					<li className="settings-option">
						<h1>Your Landing Page</h1>
						<div className="note">The default page that will load when you land on the site</div>
						<ul>
							<li className={ `option ${ !process.env.config.section.home ? 'hidden' : '' }` } >
								<CheckboxComponent
									name="landingPage"
									id="landingPage-home"
									value="home"
									className="inLine"
									postLabel="Forum Home"
									checked={ this.state.landingPage === 'home' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="landingPage"
									id="landingPage-index"
									value="index"
									className="inLine"
									postLabel="Forums Index"
									checked={ this.state.landingPage === 'index' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
							<li className="option">
								<CheckboxComponent
									name="landingPage"
									id="landingPage-active"
									value="active"
									className="inLine"
									postLabel="Active Topics"
									checked={ this.state.landingPage === 'active' }
									multiple={ false }
									onChange={ ( e ) => this.updateState( e ) }
								/>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		);
	}
}

export default connect( settingsSelector )( SettingsComponent );



// WEBPACK FOOTER //
// ./src/components/SettingsComponent.js